import React from 'react'

const DocumentIcon =  (props) => {
  const { theme, isActive } = props
  return (
    <svg width='38px' height='32px' viewBox='0 0 38 32'>
      <g
        stroke='none'
        fill={
          isActive
            ? theme.activeIconColor
            : theme.inactiveIconColor
        }
        fillRule='nonzero'
      >
        <g>
          <path d='M11,10 L11,25 L23,25 L23,13.5845676 L19.3777001,10 L11,10 Z M11,8 L19.3777001,8 C19.9045055,8 20.4100372,8.20784934 20.7844901,8.57840166 L24.40679,12.1629693 C24.7864011,12.5386261 25,13.0505052 25,13.5845676 L25,25 C25,26.1045695 24.1045695,27 23,27 L11,27 C9.8954305,27 9,26.1045695 9,25 L9,10 C9,8.8954305 9.8954305,8 11,8 Z' />
          <path d='M26,24 L26,10.5845676 L22.3777001,7 L12,7 C12,5.8954305 12.8954305,5 14,5 L22.3777001,5 C22.9045055,5 23.4100372,5.20784934 23.7844901,5.57840166 L27.40679,9.16296929 C27.7864011,9.53862612 28,10.0505052 28,10.5845676 L28,22 C28,23.1045695 27.1045695,24 26,24 Z' />
        </g>
      </g>
    </svg>
  )
}

export default DocumentIcon


